import { ROUTE_PATH_RESOURCE_CENTRE } from '../../constants';
import { ProtectionPageTranslations } from '../types';

export const translations: ProtectionPageTranslations = {
  docTitle: 'Lost Wallet Protection',
  pageTitle: 'Lost Wallet Protection',
  featureList: [
    {
      // 'key' MUST BE the same as array index
      key: '0',
      heading: 'A lost wallet is no reason to panic &ndash; we&#39;ve got you covered',
      summary: [
        '<p>If your payment cards have been lost or stolen, log in to our website or call us as soon as possible to receive immediate',
        'protection and assistance. This service is accessible to you 24/7 from anywhere in the world:</p>',
        '<p class="text-contact-number">',
        'Toll-free (North America)',
        '<a  href="tel:+1-866-327-3078" class="text-nowrap">1-866-327-3078</a>',
        '</p>',
        '<p class="text-contact-number">',
        'Collect (International)',
        '<a  href="tel:+1-647-837-5412" class="text-nowrap">1-647-837-5412</a>',
        '</p>'
      ].join('\n')
    },
    {
      key: '1',
      heading: '',
      summary: [
        '<h2 class="feature-item-heading">One-Call or Click Card Cancellation</h2>',
        '<p>Call us or go online to have your lost or stolen payment cards cancelled.',
        'We will take on the responsibility of notifying your card issuers on your behalf.',
        '</p>',
        '<h2 class="feature-item-heading">Fraud Alert</h2>',
        '<p>At your option, we can have a fraud alert placed on your credit bureau file to indicate to',
        'lenders that you may be a victim of identity fraud and',
        'they need to take additional precautions before granting a new credit line.</p>',
        '<h2 class="feature-item-heading">Emergency Cash</h2>',
        '<p>If you are stranded more than 160km away from home due to a lost or stolen payment card, you can request',
        'up to $2,500 to be wire transferred to a location near you, which can be billed to the credit card you',
        'specify.</p>',
        '<p><strong>Need help replacing the other cards in your wallet?</strong></p>'
      ].join('\n'),
      action: {
        resourceCentre: {
          to: ROUTE_PATH_RESOURCE_CENTRE,
          children: 'Resource Centre'
        }
      }
    }
  ]
};
